import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import PrivateLayout from '../layouts/PrivateLayout';

const EtchCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/dashboard');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PrivateLayout>
      <h1>Loading...</h1>
    </PrivateLayout>
  );
};

export default EtchCallback;
